import { Component, OnInit, Input } from '@angular/core';
import{LoopBackAuth, validacionService, horarioService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalMensajeConfirmacionComponent} from '../modal/modal-mensaje-confirmacion/modal-mensaje-confirmacion.component'
import { isNull } from 'util';
@Component({
  selector: 'tabla-horarios-academicos',
  template: `

  <div class="col-xs-2 col-sm-2 col-md-2 pr-0">
    <div class="widget-box">
        <div class="widget-header">
          <ul>
            <li class ="bg-primary text-while">
              <h5 class="titulo-header-horario text-center">Horas</h5>
            </li>
          </ul>
        </div>
    </div>
    <div class="widget-body">
        <div class="widget-main">
          <ul class="list-horario">
						<li *ngFor="let hora of horas" class="text-center d-flex justify-content-center align-items-center">
                <div>{{hora.descripcion}}</div>
						</li>
					</ul>
        </div>
    </div>
  </div>
  <div class="col-xs-10 col-sm-10 col-md-10 pl-0 pr-0 ">
      <div class="columna-horario" *ngFor="let dia of dias ">
        <div class="widget-box pricing-box-small">
          <div class="widget-header">
            <ul>
              <li class ="bg-primary text-while">
                <h5 class="titulo-header-horario text-center">{{dia.abreviatura}}</h5>
              </li>
            </ul>
          </div>
          <div class="widget-body ">
            <div class="widget-main">
                <ul class="list-horario-asignatura">
                  <li  
                    dnd-droppable 
                    *ngFor="let hora of dia.horas" 
                    class="border d-flex justify-content-center align-items-center" 
                    [ngStyle]="{'background':(hora.pensum.color != undefined) ? hora.pensum.color : (hora.pensum.bloqueo) ? '#f9f9f9':'#fff'}"
                    (onDropSuccess)="addAsignaturaHorario($event, hora)">
                      <div class="text-center" 
                        [ngStyle]="{'color':(hora.pensum.bloqueo)? '#666':'#fff'}"
                        [style.font-size]="'11px'">
                        {{hora.pensum.descripcion}}
                      </div>
                      <i 
                        class="icofont icofont-ui-delete  eliminar-horario" 
                        *ngIf="hora.pensum.descripcion != '' && !preview"
                        (click)="delete(hora)"></i>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
  </div>
  `,
  providers:[LoopBackAuth, validacionService, horarioService, MessageService, ]
})
export class TablaHorariosAcademicosComponent implements OnInit {
  @Input() idCursoCompleto: any
  @Input() asignaturas : any
  @Input() preview : any = true
  dias :any =[]
  horas: any =[]
  constructor(
    private toastr: ToastrService,
    private horarioService: horarioService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.searchHorario()
  }
  searchHorario(){
    this.horarioService.findDias().subscribe(
      dias=>{
        if(!isNull(dias)){
          this.horarioService.findHoras(this.idCursoCompleto).subscribe(
            horas =>{
              if( !isNull(horas)){
                this.horarioService.findAsignaturas(this.idCursoCompleto).subscribe(
                  asignaturas =>{
                    if(!isNull(asignaturas)){
                      this.dias = this.armarHorario(dias,horas,asignaturas)
                      this.horas = this.dias[0].horas
                    }
                  }
                )
              }
            }
          )
        }
      })
  }

  armarHorario(dias:any,horas:any,asignatura:any){
    let obj = []
    for(let dia of dias){
      obj.push(
        {
          id:dia.glb_dia_id, 
          descripcion:dia.descripcion, 
          abreviatura:dia.abreviatura,
          laboral: dia.dia_laborable,
          orde:dia.orden,
          horas: this.objetoHoras(dia, horas, asignatura)
        }
      )
    }
    return obj

  }

  objetoHoras(dia, horas, asignaturas){
    let obj = []
    for(let hora of horas){
      obj.push({
        id:hora.aca_horario_hora_id, 
        descripcion:hora.descripcion,
        orden: hora.orden,
        pensum:this.objetoAsignatura(dia,hora, asignaturas)
      })
    }
    return obj
  }

  objetoAsignatura(dia,hora,asignaturas){
    let asignatura = asignaturas.filter(x=> x.glb_dia_id == dia.glb_dia_id && x.aca_horario_hora_id == hora.aca_horario_hora_id)
    let obj = {
      id:(asignatura.length > 0) ? asignatura[0].aca_horario_clase_id: null ,
      idDias:dia.glb_dia_id,
      idHora:hora.aca_horario_hora_id,
      idPensum: (asignatura.length > 0) ? asignatura[0].aca_docente_asignatura_curso_id : null,
      descripcion:(hora.receso && dia.glb_dia_id == 3) ? '' : (asignatura.length > 0) ? asignatura[0].aca_asignatura_descripcion : '' ,
      bloqueo:(!dia.dia_laborable)? true : (hora.receso) ? true :false,
      color:(asignatura.length > 0) ? this.asignaturas.filter(x=> x.id == asignatura[0].aca_docente_asignatura_curso_id)[0].color : ((!dia.dia_laborable)? true : (hora.receso) ? true :false) ? '#dedede': '#fff'
    }
    
    return obj
  }

  delete(hora){
    const ventana = this.modalService.open(ModalMensajeConfirmacionComponent,{size:'sm'})
    ventana.componentInstance.titulo ="Borrar asignatura"
    ventana.componentInstance.mensaje = "Esta seguro de eliminar la asignatura "+hora.pensum.descripcion+" del horario"
    ventana.result.then((result)=>{
      this.horarioService.deleteHorarioAsignatura(hora.pensum.id).subscribe(
        item => {
          if(item){
            hora.pensum.id = null
            hora.pensum.descripcion =''
            hora.pensum.color ='#fff'
          }
        }
      )
    },(reason)=>{

    })
  }

  addAsignaturaHorario(event,hora){
    let item = {
      id:hora.pensum.id,
      idDias:hora.pensum.idDias,
      idHora:hora.pensum.idHora,
      idPensum: event.dragData.id,
    }
 
    if(!hora.pensum.bloqueo){
      console.log("hora celda", hora.pensum)
      if(hora.pensum.id == null){
        this.horarioService.asignarHorarioAsignatura(item).subscribe(
          item => {
            if(item){
              hora.pensum.id  = item.id
              hora.pensum.descripcion =  event.dragData.acaAsignatura.descripcion
              hora.pensum.idPensum = event.dragData.id
              hora.pensum.color = event.dragData.color
            }
          }
        )
      }else{
        const ventana = this.modalService.open(ModalMensajeConfirmacionComponent,{size:'sm'})
        ventana.componentInstance.titulo ="Remplazar asignatura"
        ventana.componentInstance.mensaje = "Esta seguro de remplazar la asignatura "+hora.pensum.descripcion+" del horario"
        ventana.result.then((result)=>{
          this.horarioService.asignarHorarioAsignatura(item).subscribe(
            item => {
              if(item){
                hora.pensum.id  = item.id
                hora.pensum.descripcion =  event.dragData.acaAsignatura.descripcion
                hora.pensum.idPensum = event.dragData.id
                hora.pensum.color = event.dragData.color
              }
            }
          )
        },(reason)=>{
          
        })
      }
      
    }else{
      this.toastr.warning("El casillero esta bloqueado", "Alerta")
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/tabla-horarios-academicos.component.ts